import React from 'react';
import PropTypes from 'prop-types';
import styles from './FlyoutMenuItem.scss';
import notifyAnalytics from '../notify-analytics';

const FlyoutMenuItem = ({ label, url, hierarchy }) => {
  const navigate = () => {
    notifyAnalytics(`${hierarchy}|${label}`);
  };

  return (
    <li className={styles.flyoutMenuItem}>
      <a href={url} onClick={navigate}>
        {label}
      </a>
    </li>
  );
};

FlyoutMenuItem.propTypes = {
  label: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  hierarchy: PropTypes.string.isRequired,
};

export default FlyoutMenuItem;
